import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'premium'
})
export class PremiumPipe implements PipeTransform {

    constructor(private translationService: TranslateService) {
    }

    transform(value: number): string {
        if (value === null) {
            return null;
        }
        const premium = value.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
        const currency = this.translationService.instant('LABEL.SUFFIX_PLN');
        return `${premium} ${currency}`;
    }
}
